import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#118AB2] to-[#06D6A0] py-6 px-4">
        <div className="max-w-3xl mx-auto">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-white/80 hover:text-white mb-4">
            <ArrowLeft size={20} /> Back
          </button>
          <h1 className="text-3xl font-black text-white" style={{ fontFamily: "Fredoka, sans-serif" }}>
            Terms of Service
          </h1>
          <p className="text-white/80 mt-1">Last updated: March 5, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto py-8 px-4">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 space-y-6">
          
          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              By accessing or using Bible Buds ("the Service"), you agree to be bound by these Terms of Service. 
              If you are a parent or guardian, you agree to these terms on behalf of your child. 
              If you do not agree to these terms, please do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">2. Description of Service</h2>
            <p className="text-gray-600 leading-relaxed">
              Bible Buds is an educational platform designed to teach children about the Bible through 
              age-appropriate lessons, activities, and interactive content. The Service is intended for 
              children ages 3-18 under parental supervision.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">3. User Accounts</h2>
            <p className="text-gray-600 leading-relaxed">
              Parents or guardians must create an account to use Bible Buds. You are responsible for 
              maintaining the confidentiality of your account credentials and for all activities that 
              occur under your account. Children may only access the Service through a parent-supervised account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">4. Subscription and Payments</h2>
            <p className="text-gray-600 leading-relaxed">
              Bible Buds offers subscription plans for families and churches. By subscribing, you authorize 
              us to charge your payment method on a recurring basis. You may cancel your subscription at any 
              time. Refunds are handled in accordance with our refund policy.
            </p>
            <ul className="list-disc list-inside text-gray-600 mt-2 space-y-1">
              <li>Family Plans: $9.99/month or $69.99/year (7-day free trial)</li>
              <li>Church Plans: $39.99/month or $339.99/year</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">5. Content and Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed">
              All content on Bible Buds, including lessons, graphics, and text, is owned by Bible Buds or 
              its licensors. You may not copy, modify, distribute, or create derivative works without our 
              written permission. Bible lessons are generated using AI technology and are for educational purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">6. User Conduct</h2>
            <p className="text-gray-600 leading-relaxed">
              You agree not to use the Service for any unlawful purpose or in any way that could damage, 
              disable, or impair the Service. You agree not to attempt to gain unauthorized access to any 
              part of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">7. Termination</h2>
            <p className="text-gray-600 leading-relaxed">
              We reserve the right to suspend or terminate your account at any time for violation of these 
              terms or for any other reason at our discretion. Upon termination, your right to use the 
              Service will immediately cease.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">8. Disclaimer of Warranties</h2>
            <p className="text-gray-600 leading-relaxed">
              The Service is provided "as is" without warranties of any kind. We do not guarantee that the 
              Service will be uninterrupted, error-free, or free of harmful components.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">9. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed">
              To the maximum extent permitted by law, Bible Buds shall not be liable for any indirect, 
              incidental, special, or consequential damages arising from your use of the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">10. Changes to Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              We may update these Terms of Service from time to time. We will notify you of significant 
              changes by posting the new terms on the Service. Your continued use of the Service after 
              changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#073B4C] mb-3">11. Contact Us</h2>
            <p className="text-gray-600 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:{" "}
              <a href="mailto:support@biblebuds.space" className="text-[#118AB2] hover:underline font-semibold">
                support@biblebuds.space
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
